module.exports = __webpack_public_path__ + "img/vertical_4_2_9016.e6142e1a.png";